/**
 * @file コンポーネント：フル動画ページタイムラインシェーマ ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const TimelineItemSchema = (props) => {
    /**
     * クリックされた画像を初期表示スライドに指定して、ポップアップを表示
     */
    const fnOpenPopupSchema = (e) => {
        e.preventDefault();
        props.setClickedSlideIndex(e.currentTarget.getAttribute("data-index"));
        props.setPopupSchemaSlider(props.listSchema);
        props.setIsOpenPopupSchema(true);
        e.stopPropagation();
    };

    return <Presenter {...props} fnOpenPopupSchema={fnOpenPopupSchema} />;
};
